export function getHeaders() {
    const apiKey = localStorage.getItem('apiKey');
    const deviceId = localStorage.getItem('deviceId');
    const serial = localStorage.getItem('serial');

    if (!apiKey || !deviceId || !serial) {
        throw new Error('Missing required parameters');
    }
    return {
        "x-api-key": apiKey,
        "x-api-device": deviceId,
        "x-api-serial": serial,
    }
}
